/* eslint-disable */
import { createStore } from 'vuex'
import auth from './auth'

import createPersistedState from 'vuex-persistedstate'
import tur from './tur'
import typedef from './typedef'
import terminal from './terminal'


export default createStore({
  /*
  state: {
  },
  mutations: {
  },
  actions: {
  },
  */
  modules: {
    auth,
    typedef,
    tur,
    terminal
  },
  plugins: [createPersistedState()],
})

